import { render, staticRenderFns } from "./InspirationsPerBrief.vue?vue&type=template&id=561711c0&scoped=true"
import script from "./InspirationsPerBrief.vue?vue&type=script&lang=js"
export * from "./InspirationsPerBrief.vue?vue&type=script&lang=js"
import style0 from "./InspirationsPerBrief.vue?vue&type=style&index=0&id=561711c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561711c0",
  null
  
)

export default component.exports